<template>
  <div>
    <basic-button></basic-button>
    <naked-button></naked-button>
    <external-button></external-button>
  </div>
</template>

<script>
import BasicButton from './Basic';
import NakedButton from './Naked';
import ExternalButton from './External';

export default {
  components: {
    BasicButton,
    NakedButton,
    ExternalButton,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?e0bcdd94
 **/